import React from "react";
import success from "../assets/subscription success.png";
import logo from "../assets/logo.png";

const SubscriptionSuccess = () => {
  return (
    <>
      <div className="container pt-5">
        <div className=" row justify-content-center">
          <img src={success} className="subscriptionImage" />
          <p className="congratulations">Congratulations!</p>
          <p className="success-paragraph">
            On your subscription, you can now enjoy all the features available <br />
            In the <img src={logo} /> mobile app.
          </p>
        </div>
      </div>
    </>
  );
};

export default SubscriptionSuccess;
